/**
 * Zeoniq.EInvoice.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CancelBillRequestModel } from '../model/cancelBillRequestModel';
import { CancelBillResponseModel } from '../model/cancelBillResponseModel';
import { CancelDocumentRequestModel } from '../model/cancelDocumentRequestModel';
import { CancelDocumentResponseModel } from '../model/cancelDocumentResponseModel';
import { ErrorResponseModel } from '../model/errorResponseModel';
import { GetSubmissionResponseModel } from '../model/getSubmissionResponseModel';
import { InvoiceQueryResponseModel } from '../model/invoiceQueryResponseModel';
import { InvoiceQueryStatusResponseModel } from '../model/invoiceQueryStatusResponseModel';
import { InvoiceResponse } from '../model/invoiceResponse';
import { ManualProcessDocRequestModel } from '../model/manualProcessDocRequestModel';
import { ManualProcessDocRequestResponseModel } from '../model/manualProcessDocRequestResponseModel';
import { SubmitConsolidatedDocRequestModel } from '../model/submitConsolidatedDocRequestModel';
import { SubmitDocRequestResponse } from '../model/submitDocRequestResponse';
import { SubmitDocumentResponseModel } from '../model/submitDocumentResponseModel';
import { SubmitIndividualDocRequestByBillModel } from '../model/submitIndividualDocRequestByBillModel';
import { SubmitIndividualDocRequestByBillResponse } from '../model/submitIndividualDocRequestByBillResponse';
import { SubmitIndividualDocRequestModel } from '../model/submitIndividualDocRequestModel';
import { TempProcessSubmissionRequestModel } from '../model/tempProcessSubmissionRequestModel';
import { TestSubmitMyInvoisRequestModel } from '../model/testSubmitMyInvoisRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DocRequestService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestCancelconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ManualProcessDocRequestResponseModel>>;
    public apiDocrequestCancelconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ManualProcessDocRequestResponseModel>>>;
    public apiDocrequestCancelconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ManualProcessDocRequestResponseModel>>>;
    public apiDocrequestCancelconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ManualProcessDocRequestResponseModel>>('post',`${this.basePath}/api/docrequest/cancelconsolidatedrequest`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestCancelrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ManualProcessDocRequestResponseModel>>;
    public apiDocrequestCancelrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ManualProcessDocRequestResponseModel>>>;
    public apiDocrequestCancelrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ManualProcessDocRequestResponseModel>>>;
    public apiDocrequestCancelrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ManualProcessDocRequestResponseModel>>('post',`${this.basePath}/api/docrequest/cancelrequest`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param orderRef 
     * @param checkCode 
     * @param verifyField 
     * @param receiptParam 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestGetlatestinvoicedataGet(orderRef?: string, checkCode?: string, verifyField?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<InvoiceQueryResponseModel>;
    public apiDocrequestGetlatestinvoicedataGet(orderRef?: string, checkCode?: string, verifyField?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InvoiceQueryResponseModel>>;
    public apiDocrequestGetlatestinvoicedataGet(orderRef?: string, checkCode?: string, verifyField?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InvoiceQueryResponseModel>>;
    public apiDocrequestGetlatestinvoicedataGet(orderRef?: string, checkCode?: string, verifyField?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderRef !== undefined && orderRef !== null) {
            queryParameters = queryParameters.set('OrderRef', <any>orderRef);
        }
        if (checkCode !== undefined && checkCode !== null) {
            queryParameters = queryParameters.set('CheckCode', <any>checkCode);
        }
        if (verifyField !== undefined && verifyField !== null) {
            queryParameters = queryParameters.set('VerifyField', <any>verifyField);
        }
        if (receiptParam !== undefined && receiptParam !== null) {
            queryParameters = queryParameters.set('ReceiptParam', <any>receiptParam);
        }

        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InvoiceQueryResponseModel>('get',`${this.basePath}/api/docrequest/getlatestinvoicedata`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param secretkey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestManualcallbackinvoicelogPost(body?: Array<number>, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, secretkey?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiDocrequestManualcallbackinvoicelogPost(body?: Array<number>, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, secretkey?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiDocrequestManualcallbackinvoicelogPost(body?: Array<number>, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, secretkey?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiDocrequestManualcallbackinvoicelogPost(body?: Array<number>, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, secretkey?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (secretkey !== undefined && secretkey !== null) {
            queryParameters = queryParameters.set('secretkey', <any>secretkey);
        }

        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/docrequest/manualcallbackinvoicelog`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestPostconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ManualProcessDocRequestResponseModel>>;
    public apiDocrequestPostconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ManualProcessDocRequestResponseModel>>>;
    public apiDocrequestPostconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ManualProcessDocRequestResponseModel>>>;
    public apiDocrequestPostconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ManualProcessDocRequestResponseModel>>('post',`${this.basePath}/api/docrequest/postconsolidatedrequest`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param orderRef 
     * @param checkCode 
     * @param verifyField 
     * @param receiptParam 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestQueryinvoiceGet(orderRef?: string, checkCode?: string, verifyField?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<InvoiceQueryResponseModel>;
    public apiDocrequestQueryinvoiceGet(orderRef?: string, checkCode?: string, verifyField?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InvoiceQueryResponseModel>>;
    public apiDocrequestQueryinvoiceGet(orderRef?: string, checkCode?: string, verifyField?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InvoiceQueryResponseModel>>;
    public apiDocrequestQueryinvoiceGet(orderRef?: string, checkCode?: string, verifyField?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderRef !== undefined && orderRef !== null) {
            queryParameters = queryParameters.set('OrderRef', <any>orderRef);
        }
        if (checkCode !== undefined && checkCode !== null) {
            queryParameters = queryParameters.set('CheckCode', <any>checkCode);
        }
        if (verifyField !== undefined && verifyField !== null) {
            queryParameters = queryParameters.set('VerifyField', <any>verifyField);
        }
        if (receiptParam !== undefined && receiptParam !== null) {
            queryParameters = queryParameters.set('ReceiptParam', <any>receiptParam);
        }

        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InvoiceQueryResponseModel>('get',`${this.basePath}/api/docrequest/queryinvoice`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param orderRef 
     * @param receiptParam 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestQueryinvoicestatusGet(orderRef?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<InvoiceQueryStatusResponseModel>;
    public apiDocrequestQueryinvoicestatusGet(orderRef?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InvoiceQueryStatusResponseModel>>;
    public apiDocrequestQueryinvoicestatusGet(orderRef?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InvoiceQueryStatusResponseModel>>;
    public apiDocrequestQueryinvoicestatusGet(orderRef?: string, receiptParam?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderRef !== undefined && orderRef !== null) {
            queryParameters = queryParameters.set('OrderRef', <any>orderRef);
        }
        if (receiptParam !== undefined && receiptParam !== null) {
            queryParameters = queryParameters.set('ReceiptParam', <any>receiptParam);
        }

        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InvoiceQueryStatusResponseModel>('get',`${this.basePath}/api/docrequest/queryinvoicestatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestRegenerateconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ManualProcessDocRequestResponseModel>>;
    public apiDocrequestRegenerateconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ManualProcessDocRequestResponseModel>>>;
    public apiDocrequestRegenerateconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ManualProcessDocRequestResponseModel>>>;
    public apiDocrequestRegenerateconsolidatedrequestPost(body?: ManualProcessDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ManualProcessDocRequestResponseModel>>('post',`${this.basePath}/api/docrequest/regenerateconsolidatedrequest`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestSubmitconsolidatedrequestPost(body?: SubmitConsolidatedDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SubmitDocRequestResponse>>;
    public apiDocrequestSubmitconsolidatedrequestPost(body?: SubmitConsolidatedDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SubmitDocRequestResponse>>>;
    public apiDocrequestSubmitconsolidatedrequestPost(body?: SubmitConsolidatedDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SubmitDocRequestResponse>>>;
    public apiDocrequestSubmitconsolidatedrequestPost(body?: SubmitConsolidatedDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<SubmitDocRequestResponse>>('post',`${this.basePath}/api/docrequest/submitconsolidatedrequest`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestSubmitindividualrequestPost(body?: SubmitIndividualDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<SubmitDocRequestResponse>;
    public apiDocrequestSubmitindividualrequestPost(body?: SubmitIndividualDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubmitDocRequestResponse>>;
    public apiDocrequestSubmitindividualrequestPost(body?: SubmitIndividualDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubmitDocRequestResponse>>;
    public apiDocrequestSubmitindividualrequestPost(body?: SubmitIndividualDocRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubmitDocRequestResponse>('post',`${this.basePath}/api/docrequest/submitindividualrequest`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestSubmitindividualrequestbybillPost(body?: SubmitIndividualDocRequestByBillModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<SubmitIndividualDocRequestByBillResponse>;
    public apiDocrequestSubmitindividualrequestbybillPost(body?: SubmitIndividualDocRequestByBillModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubmitIndividualDocRequestByBillResponse>>;
    public apiDocrequestSubmitindividualrequestbybillPost(body?: SubmitIndividualDocRequestByBillModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubmitIndividualDocRequestByBillResponse>>;
    public apiDocrequestSubmitindividualrequestbybillPost(body?: SubmitIndividualDocRequestByBillModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubmitIndividualDocRequestByBillResponse>('post',`${this.basePath}/api/docrequest/submitindividualrequestbybill`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestTestcancelbillPost(body?: CancelBillRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<CancelBillResponseModel>;
    public apiDocrequestTestcancelbillPost(body?: CancelBillRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CancelBillResponseModel>>;
    public apiDocrequestTestcancelbillPost(body?: CancelBillRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CancelBillResponseModel>>;
    public apiDocrequestTestcancelbillPost(body?: CancelBillRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CancelBillResponseModel>('post',`${this.basePath}/api/docrequest/testcancelbill`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestTestcanceldocumentPost(body?: CancelDocumentRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<CancelDocumentResponseModel>;
    public apiDocrequestTestcanceldocumentPost(body?: CancelDocumentRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CancelDocumentResponseModel>>;
    public apiDocrequestTestcanceldocumentPost(body?: CancelDocumentRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CancelDocumentResponseModel>>;
    public apiDocrequestTestcanceldocumentPost(body?: CancelDocumentRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CancelDocumentResponseModel>('post',`${this.basePath}/api/docrequest/testcanceldocument`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestTestcanceldocumentwithknockoffmethodPost(body?: CancelDocumentRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<CancelDocumentResponseModel>;
    public apiDocrequestTestcanceldocumentwithknockoffmethodPost(body?: CancelDocumentRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CancelDocumentResponseModel>>;
    public apiDocrequestTestcanceldocumentwithknockoffmethodPost(body?: CancelDocumentRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CancelDocumentResponseModel>>;
    public apiDocrequestTestcanceldocumentwithknockoffmethodPost(body?: CancelDocumentRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CancelDocumentResponseModel>('post',`${this.basePath}/api/docrequest/testcanceldocumentwithknockoffmethod`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param docRequestId 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestTestprocessindividualrequestGet(docRequestId?: number, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<InvoiceResponse>;
    public apiDocrequestTestprocessindividualrequestGet(docRequestId?: number, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InvoiceResponse>>;
    public apiDocrequestTestprocessindividualrequestGet(docRequestId?: number, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InvoiceResponse>>;
    public apiDocrequestTestprocessindividualrequestGet(docRequestId?: number, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (docRequestId !== undefined && docRequestId !== null) {
            queryParameters = queryParameters.set('docRequestId', <any>docRequestId);
        }

        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InvoiceResponse>('get',`${this.basePath}/api/docrequest/testprocessindividualrequest`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestTestprocesssubmissionstatusPost(body?: TempProcessSubmissionRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<GetSubmissionResponseModel>>;
    public apiDocrequestTestprocesssubmissionstatusPost(body?: TempProcessSubmissionRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetSubmissionResponseModel>>>;
    public apiDocrequestTestprocesssubmissionstatusPost(body?: TempProcessSubmissionRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetSubmissionResponseModel>>>;
    public apiDocrequestTestprocesssubmissionstatusPost(body?: TempProcessSubmissionRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<GetSubmissionResponseModel>>('post',`${this.basePath}/api/docrequest/testprocesssubmissionstatus`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param assignedUID 
     * @param toEmail 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestTestsendinvoiceemailGet(assignedUID?: string, toEmail?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<InvoiceQueryResponseModel>;
    public apiDocrequestTestsendinvoiceemailGet(assignedUID?: string, toEmail?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InvoiceQueryResponseModel>>;
    public apiDocrequestTestsendinvoiceemailGet(assignedUID?: string, toEmail?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InvoiceQueryResponseModel>>;
    public apiDocrequestTestsendinvoiceemailGet(assignedUID?: string, toEmail?: string, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (assignedUID !== undefined && assignedUID !== null) {
            queryParameters = queryParameters.set('assignedUID', <any>assignedUID);
        }
        if (toEmail !== undefined && toEmail !== null) {
            queryParameters = queryParameters.set('toEmail', <any>toEmail);
        }

        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InvoiceQueryResponseModel>('get',`${this.basePath}/api/docrequest/testsendinvoiceemail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param subscriptionTag 
     * @param reCaptchaToken 
     * @param contentLanguage Specify language UpperCase(ISO_639-1_codes). Default is &#x27;EN&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiDocrequestTestsubmitmyinvoisPost(body?: TestSubmitMyInvoisRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SubmitDocumentResponseModel>>;
    public apiDocrequestTestsubmitmyinvoisPost(body?: TestSubmitMyInvoisRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SubmitDocumentResponseModel>>>;
    public apiDocrequestTestsubmitmyinvoisPost(body?: TestSubmitMyInvoisRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SubmitDocumentResponseModel>>>;
    public apiDocrequestTestsubmitmyinvoisPost(body?: TestSubmitMyInvoisRequestModel, subscriptionTag?: string, reCaptchaToken?: string, contentLanguage?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (subscriptionTag !== undefined && subscriptionTag !== null) {
            headers = headers.set('SubscriptionTag', String(subscriptionTag));
        }
        if (reCaptchaToken !== undefined && reCaptchaToken !== null) {
            headers = headers.set('reCaptchaToken', String(reCaptchaToken));
        }
        if (contentLanguage !== undefined && contentLanguage !== null) {
            headers = headers.set('Content-Language', String(contentLanguage));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<SubmitDocumentResponseModel>>('post',`${this.basePath}/api/docrequest/testsubmitmyinvois`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
